/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery(document).ready(function() {
	
	// Remove empty P tags created by WP inside of Accordion and Orbit
	jQuery('.accordion p:empty, .orbit p:empty').remove();

	// Adds Flex Video to YouTube and Vimeo Embeds
	jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
		if ( jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5 ) {
		  jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
		  jQuery(this).wrap("<div class='responsive-embed'/>");
		}
	});
	
	jQuery(".hamburger").click(function() {
		jQuery('.hamburger').toggleClass("is-active");
	});	 
	
	jQuery(".js-off-canvas-overlay.is-overlay-fixed").click(function() {
		jQuery('.hamburger').toggleClass("is-active");
	});	
		
	jQuery('.gallery').featherlightGallery({
					gallery: {
						fadeIn: 300,
						fadeOut: 300, 
					},		
					openSpeed:    300,
					closeSpeed:   300
	});	  	
	
	//wochenmenu
    jQuery(".menuweek .chbutton").click(function(){
    	if(jQuery(this).hasClass("active")){
    		return;
    	}    	
    	jQuery('.menuday').fadeOut(200);
    	jQuery('.menuweek .chbutton ' ).removeClass('active');    	
    	if(jQuery(this).hasClass("chtue")){
    		jQuery(this).addClass('active');
    		//jQuery('.menuday.wednesday').addClass('active');
    		jQuery('.menuday.tuesday').delay(200).fadeIn(400);
    	}
    	else if(jQuery(this).hasClass("chwen")){
    		jQuery(this).addClass('active');
    		//jQuery('.menuday.wednesday').addClass('active');
    		jQuery('.menuday.wednesday').delay(200).fadeIn(400);
    	}
    	else if(jQuery(this).hasClass("chthur")){
    		jQuery(this).addClass('active');
    		//jQuery('.menuday.thursday').addClass('active');
    		jQuery('.menuday.thursday').delay(200).fadeIn(400);
    	}    	
     	else if(jQuery(this).hasClass("chfri")){
    		jQuery(this).addClass('active');
    		//jQuery('.menuday.friday').addClass('active');
    		jQuery('.menuday.friday').delay(200).fadeIn(400);
    	}      	
    });		
    
    //menucard
    jQuery(".spcatnavi .spbutton").click(function(){
    	if(jQuery(this).hasClass("active")){
    		return;
    	}
    	jQuery('.sparea').slideUp(400);
    	jQuery('.spcatnavi .spbutton' ).removeClass('active');
    	if(jQuery(this).hasClass("spchart")){
    		jQuery(this).addClass('active');
    		//jQuery('.sparea.spchart').addClass('active');
    		jQuery('.sparea.spchart').delay(400).slideDown(400);
    	}
    	else if(jQuery(this).hasClass("spspeisen")){
    		jQuery(this).addClass('active');
    		//jQuery('.sparea.spbreak').addClass('active');
    		jQuery('.sparea.spspeisen').delay(400).slideDown(400);
    	}    	
     	else if(jQuery(this).hasClass("spspecial")){
    		jQuery(this).addClass('active');
    		//jQuery('.sparea.spstarter').addClass('active');
    		jQuery('.sparea.spspecial').delay(400).slideDown(400);
    	}     		    	     	
    });	 
    
    
      jQuery(window).scroll(function() {
            var movepos = -jQuery(this).scrollTop()/2;
            var movepos2 = jQuery(this).scrollTop()/2;
            var movepos3 = -jQuery(this).scrollTop();
            var zoompos = 1 - jQuery(this).scrollTop()/1000;
		    var szoom = "scale(" + zoompos + ")";
		    var smove = "translateY("+ movepos + "px)"; 
		    var smove2 = "translateX("+ movepos + "px)"; 
		    var smove3 = "translateX("+ movepos2 + "px)"; 
		    var smove4 = "translateX("+ movepos3 + "px)"; 
		    jQuery(".pageheader .rightfield").css({"-moz-transform" : smove3, "-webkit-transform" : smove3}); 
		    jQuery(".pageheader .leftfield img, .pageheader .leftfield .blueover").css({"-moz-transform" : smove2, "-webkit-transform" : smove2});  
		    jQuery(".pageheader .leftfield svg").css({"-moz-transform" : smove4, "-webkit-transform" : smove4});
		      
      });	     

}); 


jQuery(window).on('pageshow',function(){
	jQuery('#preloader').fadeOut(); // will fade out the white DIV that covers the website. 
}); //code here });


